module.exports = __webpack_public_path__ + "img/banner2.3caccf04.png";